const DEFAULT_ACCESSCONTROL_STATE =   {
    isFetching: false,
    authorizationData : {
    activeAuthorization: {
        id:'',
        customerId:'',
        isWriteAccess:false
        
    },
    authorizations:[ {
    id: '',
    userId: '',
    customerId: '',
    isWriteAccess: false
    }]

    }};


export function accessControl(state = DEFAULT_ACCESSCONTROL_STATE, action) {    
    switch (action.type) {

        case 'AUTHORIZATIONS_LOADING': {        
            let newState = {
                ...state,                
                isFetching:true
                 };
               
         
            return Object.assign({}, state, newState);
        }

        case 'AUTHORIZATIONS_LOADED': {        
            //return action.accessControl;

            let newState = {           
                isFetching:false,
                authorizationData:action.authorizationData
                };
               
         
            return newState;
        }

        //Set authorizations based on the login state
        case 'LOGINSTATE_LOGGED_IN_SUCCESS': {

            let newState = {           
                isFetching:false,
                authorizationData:action.loginData.authorizationData
                };
           
            return newState;
        }

        case 'LOGIN_CREATE_FAILURE':
        {

            return state;
        }


       
        default: {
            return state;
        }
    }
}

